import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassMembership } from '../class-membership.js';
import { Teacher } from '../teacher.js';

export const decideJoinRequestMutation = registerMutation({
  operationName: 'decideJoinRequestMutation',
  type: () => Boolean,
  params: [
    { name: 'membershipID', type: () => String },
    { name: 'approve', type: () => Boolean },
  ],

  resolve: (membershipID: string, approve: boolean) => async () => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const teacherCollection = await getCollection(Teacher);
    const teacher = await teacherCollection.findOne({ userID: currentUser._id });
    if (!teacher) {
      throw new Error('Nicht autorisiert: Kein Lehrerprofil gefunden');
    }

    const membershipCollection = await getCollection(ClassMembership);
    const membership = await membershipCollection.findOne({ _id: membershipID });
    if (!membership) {
      throw new Error('Anfrage nicht gefunden');
    }
    if (membership.teacherID !== teacher._id) {
      throw new Error('Nicht autorisiert: Diese Anfrage gehört nicht zu deiner Klasse');
    }
    if (membership.status !== 'pending') {
      throw new Error('Diese Anfrage wurde bereits bearbeitet');
    }

    const result = await membershipCollection.updateOne(
      { _id: membershipID },
      { $set: { status: approve ? 'approved' : 'rejected', decidedAt: new Date().toISOString() } },
    );

    return result.matchedCount > 0;
  },
});
